import React, { useRef, useState } from 'react'
import CalendarNav from './CalendarNav'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import multiMonthPlugin from '@fullcalendar/multimonth'
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list'
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from './../../../components/ui/tooltip'
import {
    DayCellContentArg,
    EventContentArg,
} from '@fullcalendar/core/index.js';
import { Card } from './../../../components/ui/card'



function Calendar({ attendanceRecords, details, startDate, endDate }) {
    const calendarRef = useRef(FullCalendar);
    const [viewedDate, setViewedDate] = useState(new Date());
    const EventItem = ({ info }) => {
        const { event } = info;
        const statusIcons = {
            Present: '✅',
            Delay: '🕒',
            Absent: '❌',
            Leave: '🏖️',
            Holiday: '🎉',
            'Not Taken': '❔',
        };
        return (
            <div className="w-full overflow-hidden">
                {info.view.type === 'dayGridMonth' ? (
                    <div
                        style={{ backgroundColor: event.backgroundColor }}
                        className="flex w-full gap-2 rounded-md px-2 py-1 text-[0.5rem] sm:text-[0.6rem] md:text-xs"
                    >
                        <span className="text-lg">{statusIcons[event.title] || '📌'}</span>
                        <p className="line-clamp-1 w-full rounded-sm text-lg font-semibold">
                            {event.extendedProps.reason !== '' ? (<TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger>{event.title}</TooltipTrigger>
                                    <TooltipContent className='bg-white'>
                                        <p>{event.extendedProps.reason}</p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>) : event.title}
                        </p>

                    </div>
                ) : (
                    <div className="flex items-center space-x-2 rounded-md bg-opacity-20 px-3 py-2">
                        <span className="text-lg">{statusIcons[event.title] || '📌'}</span>
                        <p className="text-sm font-semibold">{event.extendedProps.reason !== '' ? (<TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger>{event.title}</TooltipTrigger>
                                <TooltipContent className='bg-white'>
                                    <p>{event.extendedProps.reason}</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>) : event.title}</p>
                    </div>
                )}
            </div>
        );
    };

    const parseCustomDate = (dateStr) => {
        const [dayName, day, month] = dateStr.split(' ');
        const months = {
            Jan: 0,
            Feb: 1,
            Mar: 2,
            Apr: 3,
            May: 4,
            Jun: 5,
            Jul: 6,
            Aug: 7,
            Sep: 8,
            Oct: 9,
            Nov: 10,
            Dec: 11,
        };
        const currentYear = new Date().getFullYear();
        return new Date(currentYear, months[month], parseInt(day));
    };

    const getStatusColor = (status) => {
        const colors = {
            Present: '#10b981', // Green
            P: '#10b981',

            Delay: '#f97316', // Orange
            D: '#f97316',

            Absent: '#dc2626', // Red
            A: '#dc2626',

            Leave: '#06b6d4', // Cyan
            L: '#06b6d4',

            Holiday: '#84cc16', // Light Green
            H: '#84cc16',

            'Not Taken': '#6b7280', // Gray
            NT: '#6b7280',
        };

        return colors[status] || '#6b7280';
    };

    const formatAttendanceEvents = (attendanceRecords) => {
        return attendanceRecords?.map((record) => {
            const today = new Date();
            const eventDate = parseCustomDate(record.date);
            eventDate.setHours(12, 0, 0, 0); // Ensure no time shift
            console.log("record", record)
            if (eventDate.getFullYear() < 2020) {
                eventDate.setFullYear(today.getFullYear());
            }
            const getFullStatusName = (status) => {
                const statusMap = {
                    P: 'Present',
                    D: 'Delay',
                    A: 'Absent',
                    L: 'Leave',
                    H: 'Holiday',
                    NT: 'Not Taken',
                };

                return statusMap[status] || 'Unknown';
            };

            return {
                title: getFullStatusName(record.status[0]) || 'N/A',
                start: eventDate.toISOString().split('T')[0],
                color: getStatusColor(record.status[0]),
                reason: record.reason || '',
            };
        });
    };

    const events = formatAttendanceEvents(attendanceRecords);

    const DayRender = ({ info, events }) => {
        return (
            <div className="flex flex-col items-center">
                <p>{info.dayNumberText}</p>
            </div>
        );
    };



    return (
        <div className="space-y-5">
            <CalendarNav
                viewedDate={viewedDate}
                startDate={startDate}
                endDate={endDate}
                setViewedDate={setViewedDate}
                calendarRef={calendarRef} />
            <Card className="p-3">
                <FullCalendar
                    ref={calendarRef}
                    timeZone="local"
                    plugins={[
                        dayGridPlugin,
                        timeGridPlugin,
                        multiMonthPlugin,
                        interactionPlugin,
                        listPlugin,
                    ]}
                    initialView="dayGridMonth"
                    headerToolbar={false}
                    // dayCellContent={(dayInfo) => <DayRender info={dayInfo} />}
                    eventContent={(eventInfo) => <EventItem info={eventInfo} />}
                    dayCellContent={(dayInfo) => (
                        <DayRender info={dayInfo} events={events} />
                    )}
                    events={events}
                    firstDay={1}
                    // allDaySlot={true}
                    slotMinTime="24:00:00"
                    slotMaxTime="00:00:00"
                    height={'auto'}
                    nowIndicator
                    datesSet={(dates) => setViewedDate(dates.view.currentStart)}
                />
            </Card>
        </div>
    )
}

export default Calendar